/** Shared cover band + card overlap dimensions for PublicFormShell and FormDesignShell. */

export const COVER_HEIGHT_XS = 180;
export const COVER_HEIGHT_SM = 240;
export const COVER_HEIGHT_MD = 280;
export const COVER_OVERLAP_XS = 140;
export const COVER_OVERLAP_SM = 120;
export const COVER_OVERLAP_MD = 100;
export const FORM_CARD_MAX_WIDTH = 780;
export const FORM_CARD_SIDE_MARGIN = 12;

export const coverHeightSx = {
  xs: `${COVER_HEIGHT_XS}px`,
  sm: `${COVER_HEIGHT_SM}px`,
  md: `${COVER_HEIGHT_MD}px`,
};

export const coverOverlapSx = {
  xs: `-${COVER_OVERLAP_XS}px`,
  sm: `-${COVER_OVERLAP_SM}px`,
  md: `-${COVER_OVERLAP_MD}px`,
};

/** Card shell over the cover band — matches PublicFormShell published layout. */
export function formCardOverCoverSx(palette, { compact = false } = {}) {
  return {
    mt: compact ? `-${COVER_OVERLAP_XS}px` : coverOverlapSx,
    mb: compact ? 4 : { xs: 4, sm: 6 },
    position: 'relative',
    bgcolor: palette.surface,
    borderRadius: '20px',
    border: `1px solid ${palette.border}`,
    px: compact ? 2.5 : { xs: 2.5, sm: 5, md: 6 },
    py: compact ? 3 : { xs: 4, sm: 6 },
    maxWidth: compact
      ? `calc(100% - ${FORM_CARD_SIDE_MARGIN * 2}px)`
      : FORM_CARD_MAX_WIDTH,
    mx: compact ? 'auto' : { xs: 2, sm: 3, md: 'auto' },
    width: compact ? `calc(100% - ${FORM_CARD_SIDE_MARGIN * 2}px)` : undefined,
  };
}
